import { resolveUrl } from "./xhr";
import { GetSizeWithAspectRatio, GetAspectRatio } from "./aspect";
import LStorage from "./storage";

declare const SDK: any;

const Module: any = {};

Module.ls = new LStorage(SDK?.localStorage, "openttd.");
Module['websocket'] = {
    url: location.protocol === "https:" ? "wss://" : "ws://",
};

window.addEventListener("resize", resizeCanvas, { capture: true });
const addEventListenerFn = window.addEventListener;
window.addEventListener = function(...args: any[]) {
    if (args[0] !== "resize") {
        addEventListenerFn.apply(window, args as any);
    } else {
        // do nothing
    }
}

window.addEventListener("contextmenu", (e) => e.preventDefault());

window.addEventListener("keydown", (e) => {
    if (e.code === "F5" || e.code === "KeyR") {
        e.preventDefault = () => {
            console.log("ignore prevent default");
        };
    }
}, { capture: true });

async function prepareRun() {
    function onProgess(percent: number) {
        const loaderText = document.getElementById("loader-text") as HTMLDivElement;
        loaderText.innerHTML = Math.round(percent) + "%";
        if (SDK?.loading) {
            SDK.loading(Math.round(percent));
        }
    }

    const [data, wasm, wasmJs, dataJs] = await Promise.all([
        resolveUrl("bin.data._.js", onProgess),
        resolveUrl("wbin.wasm"),
        resolveUrl("wbin.js"),
        resolveUrl("bin.data.js")]);


    const decoder = new TextDecoder();
    const wasmScript = decoder.decode(wasmJs);
    const dataScript = decoder.decode(dataJs);

    Module.canvas = document.getElementById("canvas");
    Module.getPreloadedPackage = (name: any, size: any) => data.buffer;
    Module.instantiateWasm = async (info: any, receiveInstance: any) => {
        const wasmModule = await WebAssembly.compile(wasm);
        const instance = await WebAssembly.instantiate(wasmModule, info);
        receiveInstance(instance, wasmModule);
    };
    Module.onRuntimeInitialized = () => setTimeout(doRun, 16);

    const moduleFn = new (Function as any)(["Module"], wasmScript);
    eval(dataScript);

    moduleFn(Module);
}

function doRun() {
    Module.targetAspect = innerWidth / innerHeight;

    (document.getElementById("loader-container") as HTMLDivElement).style.visibility = "hidden";
    const args = ["-r", innerWidth + "x" + innerHeight];

    if (SDK?.loaded) {
        const interstitialFn = SDK.interstitialAd;

        SDK.pause = Module._pause;
        SDK.resume = Module._resume;
		SDK.interstitialAd = function() {
		    SDK.pause();
		    interstitialFn().then(SDK.resume).catch(SDK.resume);
		};
        SDK.loaded().then(() => {
            Module.callMain(args);
        });
    } else {
        Module.callMain(args);
    }

    resizeCanvas();
    Module.canvas.style.visibility = "visible";
}

function resizeCanvas(e?: Event) {
    const [width, height]= GetSizeWithAspectRatio(innerWidth, innerHeight, Module.targetAspect);
    const canvas = Module.canvas;

    canvas.style.position = "relative";
    canvas.style.top = (innerHeight / 2) + "px";
    canvas.style.left = (innerWidth / 2) + "px";
    canvas.style.marginTop = (-1) * (height / 2) + "px";
    canvas.style.marginLeft = (-1) * (width / 2) + "px";
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    window.scroll(0, 1);

    e?.stopPropagation();
}

prepareRun();
